/**
 * The map's pin PNG art, resolved to URLs by file name. One glob shared by the
 * map (RestaurantMapView, which loads every designed pin and composites the
 * "Unsure" pins from the `00_noData*` base art) and the Pin Key (MapPinLegend),
 * so the two cannot drift apart. PNG, not SVG: SVGs with embedded images do not
 * draw to canvas reliably on iOS WebView (see scripts/convert-pins-to-png.js).
 */
export const pinUrls = import.meta.glob<string>('@pins-png/*.png', { query: '?url', import: 'default', eager: true });

/** URL of the pin PNG called `name` (no extension), or `undefined` when there is no such file. */
export const pinUrl = (name: string): string | undefined =>
  Object.entries(pinUrls).find(([path]) => path.split('/').pop() === `${name}.png`)?.[1];
